import Vue from 'vue';

import template from './index.html';

export default Vue.extend({
  name: 'Innovation',
  template,
  props: [
    'image',
    'type',
    'title',
    'url',
    'size',
    'color',
    'bgColor',
    'fallbackImage',
    'secondImage',
  ],

  data() {
    const img = this.type === 'img-left' || this.type === 'img-right' || this.type === 'bg-img' || this.type === 'double-img' || this.type === 'center-img' ? require(`../../../img/innovations/${this.image}`) : null; // eslint-disable-line
    const fallbackImg = this.type === 'bg-img' ? require(`../../../img/innovations/${this.fallbackImage}`) : null; // eslint-disable-line
    const secondImg = this.type === 'double-img' ? require(`../../../img/innovations/${this.secondImage}`) : null; // eslint-disable-line
    return {
      img,
      fallbackImg,
      secondImg,
    };
  },

  computed: {
    classes() {
      let classes = 'clearfix innovation ';

      switch (this.type) {
        case 'img-left':
        case 'img-right':
          classes += 'innovation--text-img';
          break;
        case 'bg-img':
          classes += 'innovation--bg-img';
          break;
        case 'text':
          classes += 'innovation--text';
          classes += ` innovation--text--${this.color}`;
          break;
        case 'title':
          classes += `innovation--title innovation--title--${this.color}`;
          break;
        case 'double-img':
          classes += 'innovation--double-img ';
          break;
        case 'center-img':
          classes += 'innovation--center-img ';
          break;
        default:
          break;
      }

      if (this.size) classes += ` innovation--${this.size}`;
      if (this.bgColor) classes += ` innovation--bg-${this.bgColor}`;

      return classes;
    },
  },
});



// WEBPACK FOOTER //
// ./src/js/components/innovation/index.js